@let showHeaderFooter = showHeaderAndFooter();
@let isLoaderMode = showLoader();

<div class="mbs-reseller-shell">
  <mbs-reseller-nav [class.d-none]="!showHeaderFooter"></mbs-reseller-nav>

  <main
    class="mbs-reseller-container"
    [class.d-none]="isLoaderMode">
    <div class="mbs-reseller-container-inner small-min-width">
      <div class="mbs-reseller-container-content-simple h-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

  @if (isLoaderMode) {
    <mbs-loader />
  }

  <mbs-reseller-footer [class.d-none]="!showHeaderFooter"></mbs-reseller-footer>

  <mbs-toasts data-position="bottom-right"></mbs-toasts>

  @if (showHeaderFooter) {
    <mbs-reseller-notifications-panel />
  }
</div>
